import React, { useState } from 'react';
import { TextInputProps as RNTextInputProps, TouchableOpacity, View } from 'react-native';
import { isDefined } from '@app/helpers/kindOf';
import { StyledInputs, StyledTextInputProps } from '../styled/form/Inputs';
import { StyledForms } from '../styled/form/Form';
import { useInput } from '@app/hooks/useInput';
import { HelperText } from '../styled/form/Label';
import { SvgEye } from '../icons/SvgEye';
import { SvgEyeOff } from '../icons/SvgEyeOff';
import { normalize } from '@app/helpers';

export interface PasswordInputProps extends RNTextInputProps, StyledTextInputProps {
  name: string;
  helper?: string;
  label?: string;
}

export const PasswordInput = ({ label, name, helper, ...props }: PasswordInputProps) => {
  const { field, error, formState } = useInput(name);

  const [blur, setBlur] = useState(true);
  const [secureTextEntry, setSecureTextEntry] = useState(true);

  const onBlur = () => {
    setBlur(true);
  }

  const onFocus = () => {
    setBlur(false);
  }

  const toggleSecureTextEntry = () => {
    setSecureTextEntry(prev => !prev);
  }

  const isFilled = isDefined(field.value);

  return (
    <StyledInputs.Holder>
      {label && <StyledInputs.Label isFilled={isFilled} isDirty={formState.isDirty} isBlurred={blur}>
        {label}
      </StyledInputs.Label>}

      {!!error && (
        <StyledForms.Error>
          <StyledForms.ErrorLabel>
            {error}
          </StyledForms.ErrorLabel>
        </StyledForms.Error>
      )}

      <View style={{ position: 'relative' }}>
        <StyledInputs.Input
          onChangeText={field.onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          value={field.value}
          ref={field.ref}
          isBlurred={blur}
          secureTextEntry={secureTextEntry}
          {...props}
        />
        
        <TouchableOpacity 
          onPress={toggleSecureTextEntry}
          style={{ 
            position: 'absolute', 
            right: 21, 
            top: '50%', 
            transform: [{ translateY: -10 }],
            zIndex: 999,
            backgroundColor: 'transparent'
          }}
          activeOpacity={0.7}
          hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        >
          {secureTextEntry ? (
            <SvgEye width={24} height={24} color="#fff" />
          ) : (
            <SvgEyeOff width={24} height={24} color="#fff" />
          )}
        </TouchableOpacity>
      </View>

      {helper && (
        <HelperText>
          {helper}
        </HelperText>
      )}
    </StyledInputs.Holder>
  );
};
